module.exports = __webpack_public_path__ + "static/media/1_en.44a33d47.png";